const Error = ({ message }: { message: string }) => {
  return <h2 className='text-red-400 text-center'>{message}</h2>;
};

export default Error;
